import type { Config } from 'tailwindcss'
import defaultConfig from '../../config/tailwind'

let appConfig: Config
export function useTailwindConfig(config: Config | undefined = undefined) {
  // If a config is provided, set it up in the singleton for future use.
  if (config) {
    appConfig = config
  }
  return appConfig || defaultConfig
}
